export default "__VITE_PUBLIC_ASSET__499402f8__"